function BillingInfoCard({ order }) {

  const customer = order?.customer || {};
  const shipping = order?.shippingAddress || {};

  const estimatedDelivery = order?.createdAt
    ? new Date(
        new Date(order.createdAt).getTime() + (4 * 24 * 60 * 60 * 1000)
      ).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      })
    : "—";

  return (

    <div style={styles.card}>

      <div style={styles.title}>
        Billing Info
      </div>

      <div style={styles.text}>
        {customer.firstName} {customer.lastName}
      </div>

      <div style={styles.text}>
        {shipping.city}, {shipping.state} {shipping.zip}
      </div>

      <div style={styles.text}>
        {customer.email}
      </div>

      {customer.phone && (
        <div style={styles.text}>
          {customer.phone}
        </div>
      )}

      <div style={styles.divider}></div>

      <div style={styles.deliveryLabel}>
        Estimated Delivery:
      </div>

      <div style={styles.deliveryDate}>
        Arriving around {estimatedDelivery}
      </div>

    </div>

  );

}

export default BillingInfoCard;

const styles = {

  card:{
    padding:28,
    borderRadius:22,

    background:"linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

    border:"2px solid #ffffff",

    boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)",

    fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
  },

  title:{
    fontSize:18,
    fontWeight:600,
    marginBottom:16,
    color:"#1D1D1F"
  },

  text:{
    fontSize:15,
    marginBottom:6,
    color:"#1D1D1F"
  },

  divider:{
    height:1,
    background:"rgba(0,0,0,0.05)",
    margin:"16px 0"
  },

  deliveryLabel:{
    fontSize:14,
    color:"#6E6E73"
  },

  deliveryDate:{
    fontSize:15,
    fontWeight:500,
    color:"#2D6CFF",
    marginTop:4
  }

};